import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { User } from '../../models/users.model';
import { RouteInfo } from '../../models/sidebar';
import { OPTIONS } from '../../constants/menu';
import { appConfigs } from '../../constants/initialize';
import { hasPermission } from 'src/app/utils/filterMenu';

export const ROUTES: RouteInfo[] = OPTIONS;

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit {
    @Output() logout = new EventEmitter();
    @Output() minifiedSidebar = new EventEmitter();
    myAbilities: string[];
    menuItems: RouteInfo[];
    isCollapsed = true;
    user: User;
    private menus = JSON.parse(JSON.stringify(ROUTES));
    ngOnInit() {
        if (localStorage.getItem('user')) {
            this.user = JSON.parse(localStorage.getItem('user'));
            this.myAbilities = this.user.my_permission;
        }
        this.menuItems = this.menus
            .map((menuItem) => {
                const newMenuItem = { ...menuItem };
                if (menuItem.children && Array.isArray(menuItem.children)) {
                    newMenuItem.children = menuItem.children.filter(child => {
                        return hasPermission(child, this.user);
                    });
                }
                if (menuItem.children?.length === 0) {
                    return false;
                }
                return newMenuItem;
            })
            .filter((menuItem) => hasPermission(menuItem, this.user));
    }

    optCollapsing(event, menuitem) {
        event.preventDefault();
        event.stopPropagation();
        if (menuitem !== undefined && menuitem.isCollapsing === undefined) {
            menuitem.isCollapsing = true;
        }
    }

    isCollapsing(event, menuitem) {
        event.preventDefault();
        event.stopPropagation();
        return menuitem.isCollapsed = !menuitem.isCollapsed;
    }

    isFather(menuitem: RouteInfo) {
        return menuitem.type === appConfigs.typeFather;
    }
    checkAbilitiesInRol(abilities: string[]): boolean {
         let exists = false;
         abilities.forEach((ability) => {
            exists = true;
            //  if (this.myAbilities.includes(ability)) {
            //      exists = true;
            //  }
         });
         return exists;
    }
    haveAbilityWithoutFather(menuitem: RouteInfo, abilities: string[]): boolean {
        return !this.isFather(menuitem) && this.checkAbilitiesInRol(abilities);
    }
    haveAbilityWithFather(menuitem: RouteInfo, abilities: string[]): boolean {
        return this.isFather(menuitem) && this.checkAbilitiesInRol(abilities);
    }
}
